/**
 * This file includes all remote apis.
 */

const baseUrl = ''; // BaseUrl

export const hr = {
  //* *******************工资管理*****************************
  CORE_HR_WAGE_LIST: `${baseUrl}/api/bszb/hr/wage/org`, // 获取组织列表
  GET_WAGE_LIST: `${baseUrl}/api/bszb/hr/wage/list`, // 工资记录
  GET_WAGE_MY: `${baseUrl}/api/bszb/hr/wage/my`, // 我的工资申请
  GET_WAGE_CHECK: `${baseUrl}/api/bszb/hr/wage/my/check`, // 我的工资审核
  GET_WAGE_RECORD_ORG: `${baseUrl}/api/bszb/hr/wage/listByOrg`, // 工资记录按单位
  GET_WAGE_INFO: `${baseUrl}/api/bszb/hr/wage/info`, // 工资详情
  WAGE_SAVE: `${baseUrl}/api/bszb/hr/wage/save`, // 工资保存
  WAGE_DELETE: `${baseUrl}/api/bszb/hr/wage/delete`, // 工资删除
  WAGE_NEXT: `${baseUrl}/api/bszb/hr/wage/nextActivity`, // 流程审核
  WAGE_RETURN: `${baseUrl}/api/bszb/hr/wage/returnActivity`, // 工资流程打回
  WAGE_CALLBACK: `${baseUrl}/api/bszb/hr/wage/callbackActivity`, // 工资流程收回
  WAGE_WORKFLOW: `${baseUrl}/api/bszb/hr/wage/workflow`, // 工资流程申请流程
  WAGE_IMPORT: `${baseUrl}/api/bszb/hr/wage/import`, // 工资明细导入
  WAGE_STATIC_C_M: `${baseUrl}/api/bszb/hr/wage/statisicByCompanyAndMonth`, // 工资单月统计
  WAGE_DETAIL_LIST: `${baseUrl}/api/bszb/hr/wage/detail/list`, // 工资明细详情
  WAGE_DETAIL_INFO: `${baseUrl}/api/bszb/hr/wage/detail/info`, // 工资明细详情
  WAGE_DETAIL_PERSONAL: `${baseUrl}/api/bszb/hr/wage/detail/personal`, // 工资条详情
  WAGE_SEND_ALL: `${baseUrl}/api/bszb/hr/wage/detail/sendAll`, // 工资条全部发送
  WAGE_SEND: `${baseUrl}/api/bszb/hr/wage/detail/send`, // 工资条发送
  WAGE_BACK: `${baseUrl}/api/bszb/hr/wage/detail/back`, // 工资条回收
  DOWNLOAD_WAGE_TEMPLATE: `${baseUrl}/api/bszb/hr/wage/template`, // 工资条回收
  WAGE_BACK_ALL: `${baseUrl}/api/bszb/hr/wage/detail/backAll`, // 工资条全部回收
  WAGE_STATISTIC: `${baseUrl}/api/bszb/hr/wage/statistic`, // 公司薪酬统计
  //* *******************年终奖管理*****************************
  GET_BONUS_LIST: `${baseUrl}/api/bszb/hr/bonus/list`, // 年终奖记录
  GET_BONUS_MY: `${baseUrl}/api/bszb/hr/bonus/my`, // 我的年终奖申请
  GET_BONUS_CHECK: `${baseUrl}/api/bszb/hr/bonus/my/check`, // 我的年终奖审核
  GET_BONUS_RECORD_ORG: `${baseUrl}/api/bszb/hr/bonus/listByOrg`, // 年终奖记录按单位
  GET_BONUS_INFO: `${baseUrl}/api/bszb/hr/bonus/info`, // 年终奖详情
  BONUS_SAVE: `${baseUrl}/api/bszb/hr/bonus/save`, // 年终奖保存
  BONUS_DELETE: `${baseUrl}/api/bszb/hr/bonus/delete`, // 年终奖保存
  BONUS_NEXT: `${baseUrl}/api/bszb/hr/bonus/nextActivity`, // 流程审核
  BONUS_RETURN: `${baseUrl}/api/bszb/hr/bonus/returnActivity`, // 年终奖流程打回
  BONUS_CALLBACK: `${baseUrl}/api/bszb/hr/bonus/callbackActivity`, // 年终奖流程收回
  BONUS_WORKFLOW: `${baseUrl}/api/bszb/hr/bonus/workflow`, // 年终奖流程申请流程
  BONUS_IMPORT: `${baseUrl}/api/bszb/hr/bonus/import`, // 年终奖明细导入
  BONUS_STATIC_C_M: `${baseUrl}/api/bszb/hr/bonus/statisticByCompanyAndYear`, // 年终奖单月统计
  BONUS_DETAIL_LIST: `${baseUrl}/api/bszb/hr/bonus/detail/list`, // 年终奖明细详情
  BONUS_DETAIL_INFO: `${baseUrl}/api/bszb/hr/bonus/detail/info`, // 年终奖明细详情
  BONUS_SEND_ALL: `${baseUrl}/api/bszb/hr/bonus/detail/sendAll`, // 年终奖条全部发送
  BONUS_SEND: `${baseUrl}/api/bszb/hr/bonus/detail/send`, // 年终奖条发送
  BONUS_BACK: `${baseUrl}/api/bszb/hr/bonus/detail/back`, // 年终奖条回收
  DOWNLOAD_BONUS_TEMPLATE: `${baseUrl}/api/bszb/hr/bonus/template`, // 工资条回收
  BONUS_BACK_ALL: `${baseUrl}/api/bszb/hr/bonus/detail/backAll`, // 年终奖条全部回收

  HR_WORKORG_SEARCH: `${baseUrl}/api/bszb/hr/workOrg/search`, // 业务部门列表,
  HR_WORKORG_SAVE: `${baseUrl}/api/bszb/hr/workOrg/save`, // 保存业务部门列表,
  HR_WORKORG_DELETE: `${baseUrl}/api/bszb/hr/workOrg/delete`, // 删除业务部门列表,
  HR_WORKORG_LIST: `${baseUrl}/api/bszb/hr/workOrg/list`, // 业务部门列表,
  HR_WORKORG_HR_LIST: `${baseUrl}/api/bszb/hr/workOrg/hr/list`, // 业务部门关联的人员
  HR_WORKORG_HR_SAVE: `${baseUrl}/api/bszb/hr/workOrg/hr/save`, // 业务部门关联用户
  HR_WORKORG_HR_DELETE: `${baseUrl}/api/bszb/hr/workOrg/hr/delete`, // 业务部门删除关联用户
  HR_WORKORG_HR_DELETES: `${baseUrl}/api/bszb/hr/workOrg/hr/deletes`, // 业务部门删除关联用户

  // 员工管理
  HR_LIST: `${baseUrl}/api/bszb/hr/list`, // 人员列表
  HR_INFO: `${baseUrl}/api/bszb/hr/info`, // 人员信息
  HR_REGISTER: `${baseUrl}/api/bszb/hr/register`, // 注册账号
  HR_SAVE: `${baseUrl}/api/bszb/hr/save`, // 保存帐号
  HR_DISABLE: `${baseUrl}/api/bszb/hr/disable`, // 用户禁用
  HR_ENABLE: `${baseUrl}/api/bszb/hr/enable`, // 用户启用
  HR_RESET_PWD: `${baseUrl}/api/bszb/hr/resetPwd`, // 帐号重置密码
  HR_EXPORT: `${baseUrl}/api/bszb/hr/export`, // 用户导出
  HR_IMPORT: `${baseUrl}/api/bszb/hr/import`, // 用户导入
  HR_DELETE: `${baseUrl}/api/bszb/hr/delete`, // 用户删除
  DOWNLOAD_HR_TEMPLATE: `${baseUrl}/api/bszb/hr/template`, // 下载用户导入模板
  HR_HANDOVER: `${baseUrl}/api/bszb/workflow/instance/activity/handover`, // 离职流程交接
};

export const finance = {
  /** 资金流水记录 */
  INCOME_CUSTOM_RELATE: `${baseUrl}/api/bszb/finance/books/income/custom/relate`, // 资金关联客户
  BUDGET_GROUP_SET_AIMS: `${baseUrl}/api/bszb/finance/budget/group/set/aim/save`, // 预算目标收入设置
  BUDGET_GROUP_GET_AIMS: `${baseUrl}/api/bszb/finance/budget/group/set/aim/info`, // 获得预算目标收入

  /** 预算调整 */
  BUDGET_GET_ADJUST_MY: `${baseUrl}/api/bszb/finance/budget/group/set/adjustment/my`, // 我的预算添加流程
  BUDGET_GET_ADJUST_WATCH: `${baseUrl}/api/bszb/finance/budget/group/set/adjustment/list`, // 预算添加流程列表
  BUDGET_GET_ADJUSTABLE: `${baseUrl}/api/bszb/finance/budget/group/set/adjustment/adjustable`, // 预算调整可调整金额
  BUDGET_GET_ACCOUNT: `${baseUrl}/api/bszb/finance/budget/group/account/list`, // 预算列表余额明细
  BUDGET_GET_ADJUSTMENT_WORKFLOW: `${baseUrl}/api/bszb/finance/budget/group/set/adjustment/workflow`, // 预算发起流程显示
  BUDGET_GET_ADJUSTMENT_INFO: `${baseUrl}/api/bszb/finance/budget/group/set/adjustment/info`, // 预算调整编辑获得明细
  BUDGET_ADJUSTMENT_SAVE: `${baseUrl}/api/bszb/finance/budget/group/set/adjustment/save`, // 预算调整保存
  BUDGET_ADJUSTMENT_DELETE: `${baseUrl}/api/bszb/finance/budget/group/set/adjustment/delete`, // 预算调整删除
  BUDGET_ADJUSTMENT_NEXT: `${baseUrl}/api/bszb/finance/budget/group/set/adjustment/nextActivity`, // 预算调整流程审核
  BUDGET_ADJUSTMENT_RETURN: `${baseUrl}/api/bszb/finance/budget/group/set/adjustment/returnActivity`, // 预算调整流程打回
  BUDGET_ADJUSTMENT_CALLBACK: `${baseUrl}/api/bszb/finance/budget/group/set/adjustment/callbackActivity`, // 预算调整流程收回

  /** 预算设置 */
  BUDGET_GET_SET_MY: `${baseUrl}/api/bszb/finance/budget/group/set/new/my`, // 我的预算设置流程
  BUDGET_GET_SET_WATCH: `${baseUrl}/api/bszb/finance/budget/group/set/new/list`, // 预设置流程列表
  BUDGET_GET_SET_INFO: `${baseUrl}/api/bszb/finance/budget/group/set/new/info`, // 预算设置详情
  BUDGET_SET_SAVE: `${baseUrl}/api/bszb/finance/budget/group/set/new/save`, // 预算设置保存
  BUDGET_SET_DELETE: `${baseUrl}/api/bszb/finance/budget/group/set/new/delete`, // 预算设置删除
  BUDGET_GET_SET_WORKFLOW: `${baseUrl}/api/bszb/finance/budget/group/set/new/workflow`, // 预算设置流程申请流程
  BUDGET_SET_NEXT: `${baseUrl}/api/bszb/finance/budget/group/set/new/nextActivity`, // 流程审核
  BUDGET_SET_RETURN: `${baseUrl}/api/bszb/finance/budget/group/set/new/returnActivity`, // 预算设置流程打回
  BUDGET_SET_CALLBACK: `${baseUrl}/api/bszb/finance/budget/group/set/new/callbackActivity`, // 预算设置流程收回
  DOWNLOAD_GROUP_SET_TEMPLATE: `${baseUrl}/api/bszb/finance/budget/group/set/template`, // 预算设置模板

  /** 收支分析 */
  BUDGET_GET_ANALYSIS: `${baseUrl}/api/bszb/finance/budget/group/statistics/analysis`, // 收支分析
  BUDGET_GET_ANALYSIS_INCOME: `${baseUrl}/api/bszb/finance/budget/group/statistics/analysis/income`, // 收入分析明细
  BUDGET_GET_ANALYSIS_INCOME_EXPORT: `${baseUrl}/api/bszb/finance/budget/group/statistics/analysis/income/export`, // 收入分析明细
  BUDGET_GET_ANALYSIS_FUNDS: `${baseUrl}/api/bszb/finance/budget/group/statistics/analysis/funds/type`, // 财务数据分析
  BUDGET_GET_ANALYSIS_FUNDS_MONTH: `${baseUrl}/api/bszb/finance/budget/group/statistics/analysis/funds/month`, // 财务数据分析月份

  BUDGET_GET_ANALYSIS_EXPENDITURE: `${baseUrl}/api/bszb/finance/budget/group/statistics/analysis/expenditure`, // 支出分析明细
  BUDGET_GET_ANALYSIS_BUDGET: `${baseUrl}/api/bszb/finance/budget/group/statistics/analysis/budget/type`, // 财务数据分析
  BUDGET_GET_ANALYSIS_BUDGET_MONTH: `${baseUrl}/api/bszb/finance/budget/group/statistics/analysis/budget/month`, // 财务数据分析月份
  BUDGET_GET_ANALYSIS_BUDGETS: `${baseUrl}/api/bszb/finance/budget/group/statistics/record`, // 收支分析预算统计
  BUDGET_GET_ANALYSIS_OPERATIONAL: `${baseUrl}/api/bszb/finance/budget/group/statistics/operational/report`, // 收支分析运营报表
  BUDGET_GET_ANALYSIS_OPERATIONAL_DETAIL: `${baseUrl}/api/bszb/finance/budget/group/statistics/operational/report/detail`, // 收支分析运营报表详情
  BUDGET_GET_ANALYSIS_PROFIT: `${baseUrl}/api/bszb/finance/budget/group/statistics/profit`, // 收支分析利润追踪
  BUDGET_GET_ANALYSIS_PROFIT_DETAIL: `${baseUrl}/api/bszb/finance/budget/group/statistics/profit/detail`, // 收支分析利润追踪列表
  BUDGET_GET_ANALYSIS_EXPENDITURE_EXPORT: `${baseUrl}/api/bszb/finance/budget/group/statistics/analysis/expenditure/export`, // 导出
  /* ----------------------财务管理----------------------------------------------------------------------------------*/
  //* *******************资金管理*****************************
  //* *****资金账号管理**********
  FINANCE_BOOKS_LIST: `${baseUrl}/api/bszb/finance/books/list`, // 账号列表,
  FINANCE_BOOKS_INFO: `${baseUrl}/api/bszb/finance/books/info`, // 账号明细,
  FINANCE_BOOKS_SAVE: `${baseUrl}/api/bszb/finance/books/save`, // 账号保存,
  FINANCE_BOOKS_EDIT: `${baseUrl}/api/bszb/finance/books/edit`, // 账号保存,
  FINANCE_BOOKS_DELETE: `${baseUrl}/api/bszb/finance/books/delete`, // 账号删除
  FINANCE_BOOKS_List_STATISTICS: `${baseUrl}/api/bszb/finance/books/list/statistics`, // 账号统计
  FINANCE_BOOKS_STATISTICS: `${baseUrl}/api/bszb/finance/books/statistics`, // 账号统计
  FINANCE_BOOKS_ORG: `${baseUrl}/api/bszb/finance/books/all`, // 有账号的公司列表,
  FINANCE_BOOKS_ORG_LIST: `${baseUrl}/api/bszb/finance/books/listByGroupUuids`, // 有账号的公司列表(通过预算组选择)
  FINANCE_BOOKS_CHECK_ERR: `${baseUrl}/api/bszb/finance/books/checkAmountErr`, // 检查账户余额统计,
  //* *****资金流水管理**********
  BOOKS_INCOME_LIST: `${baseUrl}/api/bszb/finance/books/income/list`, // 账号流水列表
  BOOKS_INCOME_REMOVE_LIST: `${baseUrl}/api/bszb/finance/books/income/remove/list`, // 账号已删除流水列表
  BOOKS_INCOME_INFO: `${baseUrl}/api/bszb/finance/books/income/info`, // 账号流水详情
  BOOKS_INCOME_SAVE: `${baseUrl}/api/bszb/finance/books/income/save`, // 账号流水保存
  BOOKS_INCOME_DELETE: `${baseUrl}/api/bszb/finance/books/income/delete`, // 账号流水删除
  BOOKS_INCOME_DELETES: `${baseUrl}/api/bszb/finance/books/income/deletes`, // 账号流水删除(多选)
  BOOKS_INCOME_IMPORT: `${baseUrl}/api/bszb/finance/books/income/import`, // 银行流水导入
  BOOKS_INCOME_NON_BUSINESS: `${baseUrl}/api/bszb/finance/books/income/nonBusiness`, // 账号列表,
  //* *****资金统计**************
  FINANCE_INCOME_STATISTICS: `${baseUrl}/api/bszb/finance/books/income/statistics`, // 资金统计
  FINANCE_OPERATIONAL_STATISTICS: `${baseUrl}/api/bszb/finance/books/income/operational/report`, // 资金运营统计
  FINANCE_OPERATIONAL_STATISTICS_DETAIL: `${baseUrl}/api/bszb/finance/books/income/operational/report/detail`, // 资金运营统计按年统计
  FINANCE_INCOME_PAY_STATISTICS: `${baseUrl}/api/bszb/finance/books/income/pay/statistics`, // 走账数据统计
  FINANCE_BUDGET_EXPEND: `${baseUrl}/api/bszb/finance/budget/type/list`, // 预算类目列表
  FINANCE_INCOME_DETAIL: `${baseUrl}/api/bszb/finance/books/income/statistics/detail`, // 资金统计

  //* *******************资金帐号(现金帐,数字货币,股票)管理*****************************

  //* *****资金统计**************

  FUNDS_BOOK_LIST: `${baseUrl}/api/bszb/finance/funds/book/list`, // 账号列表,
  FUNDS_BOOK_LIST_ALL: `${baseUrl}/api/bszb/finance/funds/book/listAll`, // 账号所有列表,
  FUNDS_BOOK_INFO: `${baseUrl}/api/bszb/finance/funds/book/info`, // 账号明细,
  FUNDS_BOOK_SAVE: `${baseUrl}/api/bszb/finance/funds/book/save`, // 账号保存,
  FUNDS_BOOK_ENABLE: `${baseUrl}/api/bszb/finance/funds/book/enable`, // 账号启用,
  FUNDS_BOOK_DISABLE: `${baseUrl}/api/bszb/finance/funds/book/disable`, // 账号禁用,
  FUNDS_BOOK_DELETE: `${baseUrl}/api/bszb/finance/funds/book/delete`, // 账号删除
  FUNDS_BOOK_STATISTICS: `${baseUrl}/api/bszb/finance/funds/book/statistics`, // 账号统计
  //* *****资金流水管理**********
  FUNDS_RECORD_LIST: `${baseUrl}/api/bszb/finance/funds/record/list`, // 账号流水列表,
  FUNDS_RECORD_INFO: `${baseUrl}/api/bszb/finance/funds/record/info`, // 账号流水列表,
  FUNDS_RECORD_SAVE: `${baseUrl}/api/bszb/finance/funds/record/save`, // 账号流水列表,
  FUNDS_RECORD_RELATE: `${baseUrl}/api/bszb/finance/funds/record/relate`, // 帐号流水关联银行流水,
  FUNDS_RECORD_IMPORT: `${baseUrl}/api/bszb/finance/funds/record/import`, // 银行流水导入,
  FUNDS_RECORD_INCOME: `${baseUrl}/api/bszb/finance/funds/record/income`, // 未关联的资金记录,
  DOWNLOAD_FUNDS_RECORD_TEMPLATE: `${baseUrl}api/bszb/finance/funds/record/template`, // 资金帐号模板,

  /* ----------------------budget-------------------------------------------------------------------------------*/
  //* *****预算组管理****************
  BUDGET_GROUP_SUM: `${baseUrl}/api/bszb/finance/budget/group/statistics/sum`, // 预算管理的总计
  BUDGET_GROUP_LIST: `${baseUrl}/api/bszb/finance/budget/group/list`, // 预算组列表,
  BUDGET_GROUP_PER_LIST: `${baseUrl}/api/bszb/finance/budget/group/personalList`, // 预算组列表,
  BUDGET_GROUP_INFO: `${baseUrl}/api/bszb/finance/budget/group/info`, // 预算组明细,
  BUDGET_GROUP_SAVE: `${baseUrl}/api/bszb/finance/budget/group/save`, // 预算组保存,
  BUDGET_GROUP_MY: `${baseUrl}/api/bszb/finance/budget/group/my/project`, // 我的项目预算,

  BUDGET_GROUP_SET_LIST: `${baseUrl}/api/bszb/finance/budget/group/set/list`, // 预算组设置列表,
  BUDGET_GROUP_SET_SAVE: `${baseUrl}/api/bszb/finance/budget/group/set/save`, // 添加预算组设置,
  BUDGET_GROUP_SET_BATCHIMPORT: `${baseUrl}/api/bszb/finance/budget/group/set/batchImport`, // 按季节导入预算设置,
  BUDGET_GROUP_SET_DETAIL: `${baseUrl}/api/bszb/finance/budget/group/set/detail`, // 预算设置明细,
  BUDGET_GROUP_SET_TEMPLATE: `${baseUrl}/api/bszb/finance/budget/group/set/template`, // 模板下载,

  BUDGET_GROUP_RECORD_LIST: `${baseUrl}/api/bszb/finance/budget/group/record/list`, // 预算流水列表,
  BUDGET_GROUP_BOOK_LIST: `${baseUrl}/api/bszb/finance/budget/group/record/book/list`, // 预算流水列表,
  BUDGET_GROUP_RECORD_ADD: `${baseUrl}/api/bszb/finance/budget/group/record/add`, // 预算流水添加,
  BUDGET_GROUP_RECORD_INFO: `${baseUrl}/api/bszb/finance/budget/group/record/info`, // 预算流水明细,
  BUDGET_GROUP_RECORD_DELETE: `${baseUrl}/api/bszb/finance/budget/group/record/delete`, // 预算流水删除,
  BUDGET_GROUP_RECORD_UPDATE: `${baseUrl}/api/bszb/finance/budget/group/record/update`, // 预算记录修改,

  BUDGET_APPORTION_LIST: `${baseUrl}/api/bszb/finance/budget/apportion/info`, // 预算流水列表,
  BUDGET_RECORD_STATIS_MONTH: `${baseUrl}/api/bszb/finance/budget/group/statistics/record/month`, // 预算流水统计按月
  BUDGET_RECORD_STATIS: `${baseUrl}/api/bszb/finance/budget/group/record/statistics`, // 预算流水统计
  FINANCE_EXPORT: `${baseUrl}/api/bszb/finance/budget/group/statistics/analysis/income/export`, // 导出

  BUDGET_GRUOP_ENABLE: `${baseUrl}/api/bszb/finance/budget/group/enable`, // 预算组启用,
  BUDGET_GRUOP_DISABLE: `${baseUrl}/api/bszb/finance/budget/group/disable`, // 预算组禁用,
  BUDGET_GRUOP_GETCAF: `${baseUrl}/api/bszb/finance/budget/group/currentAndFreeze`, // 获取当前预算组的当前余额与冻结金额
  CAPITAL_ENABLE: `${baseUrl}/api/bszb/finance/books/enable`, // 资金账户启用,
  CAPITAL_DISABLE: `${baseUrl}/api/bszb/finance/books/disable`, // 资金账户禁用,

  //* *******************报销*****************************
  GET_RECOUP_LIST: `${baseUrl}/api/bszb/finance/recoup/list`, // 报销记录
  GET_RECOUP_MY: `${baseUrl}/api/bszb/finance/recoup/my`, // 我的报销申请
  GET_RECOUP_CHECK: `${baseUrl}/api/bszb/finance/recoup/my/check`, // 我的报销审核
  GET_RECOUP_STATIC_ORG: `${baseUrl}/api/bszb/finance/recoup/statisticByOrg`, // 报销统计按单位
  GET_RECOUP_STATIC_INCUBATOR: `${baseUrl}/api/bszb/finance/recoup/statisticByIncubator`, // 报销统计按孵化器
  GET_RECOUP_RECORD_ORG: `${baseUrl}/api/bszb/finance/recoup/listByOrg`, // 报销记录按单位
  GET_RECOUP_INFO: `${baseUrl}/api/bszb/finance/recoup/info`, // 报销详情
  RECOUP_SAVE: `${baseUrl}/api/bszb/finance/recoup/save`, // 报销保存
  RECOUP_DELETE: `${baseUrl}/api/bszb/finance/recoup/delete`, // 报销删除
  RECOUP_NEXT: `${baseUrl}/api/bszb/finance/recoup/nextActivity`, // 流程审核
  RECOUP_RETURN: `${baseUrl}/api/bszb/finance/recoup/returnActivity`, // 报销流程打回
  RECOUP_CALLBACK: `${baseUrl}/api/bszb/finance/recoup/callbackActivity`, // 报销流程收回
  RECOUP_WORKFLOW: `${baseUrl}/api/bszb/finance/recoup/workflow`, // 报销流程申请流程

  //* *******************付款*****************************
  GET_PAYMENT_LIST: `${baseUrl}/api/bszb/finance/payment/list`, // 付款记录
  GET_PAYMENT_MY: `${baseUrl}/api/bszb/finance/payment/my`, // 我的付款申请
  GET_PAYMENT_CHECK: `${baseUrl}/api/bszb/finance/payment/my/check`, // 我的付款审核
  GET_PAYMENT_STATIC_ORG: `${baseUrl}/api/bszb/finance/payment/statisticByOrg`, // 付款统计按单位
  GET_PAYMENT_STATIC_INCUBATOR: `${baseUrl}/api/bszb/finance/payment/statisticByIncubator`, // 付款统计按孵化器
  GET_PAYMENT_RECORD_ORG: `${baseUrl}/api/bszb/finance/payment/listByOrg`, // 付款记录按单位
  GET_PAYMENT_INFO: `${baseUrl}/api/bszb/finance/payment/info`, // 付款详情
  PAYMENT_SAVE: `${baseUrl}/api/bszb/finance/payment/save`, // 付款保存
  PAYMENT_DELETE: `${baseUrl}/api/bszb/finance/payment/delete`, // 付款保存
  PAYMENT_NEXT: `${baseUrl}/api/bszb/finance/payment/nextActivity`, // 流程审核
  PAYMENT_RETURN: `${baseUrl}/api/bszb/finance/payment/returnActivity`, // 付款流程打回
  PAYMENT_CALLBACK: `${baseUrl}/api/bszb/finance/payment/callbackActivity`, // 付款流程收回
  PAYMENT_WORKFLOW: `${baseUrl}/api/bszb/finance/payment/workflow`, // 付款流程申请流程
  PAYMENT_INCOMEPART: `${baseUrl}/api/bszb/finance/payment/listByIncomepart`, // 付款方的付款记录

  //* *******************借款*****************************
  GET_LOAN_LIST: `${baseUrl}/api/bszb/finance/loan/list`, // 借款记录
  GET_LOAN_MY: `${baseUrl}/api/bszb/finance/loan/my`, // 我的借款申请
  GET_LOAN_CHECK: `${baseUrl}/api/bszb/finance/loan/my/check`, // 我的借款审核
  GET_LOAN_STATIC_ORG: `${baseUrl}/api/bszb/finance/loan/statisticByOrg`, // 借款统计按单位
  GET_LOAN_STATIC_INCUBATOR: `${baseUrl}/api/bszb/finance/loan/statisticByIncubator`, // 借款统计按孵化器
  GET_LOAN_RECORD_ORG: `${baseUrl}/api/bszb/finance/loan/listByOrg`, // 借款记录按单位
  GET_LOAN_INFO: `${baseUrl}/api/bszb/finance/loan/info`, // 借款详情
  LOAN_SAVE: `${baseUrl}/api/bszb/finance/loan/save`, // 借款保存
  LOAN_DELETE: `${baseUrl}/api/bszb/finance/loan/delete`, // 借款删除
  LOAN_NEXT: `${baseUrl}/api/bszb/finance/loan/nextActivity`, // 流程审核
  LOAN_RETURN: `${baseUrl}/api/bszb/finance/loan/returnActivity`, // 借款流程打回
  LOAN_CALLBACK: `${baseUrl}/api/bszb/finance/loan/callbackActivity`, // 借款流程收回
  LOAN_WORKFLOW: `${baseUrl}/api/bszb/finance/loan/workflow`, // 借款流程申请流程
  GET_LOAN_WRITE_INFO: `${baseUrl}/api/bszb/finance/loan/write/off/info`, // 借款核销详情
  LOAN_WRITE_SAVE: `${baseUrl}/api/bszb/finance/loan/write/off/save`, // 借款保存

  //* *******************开票*****************************
  GET_INVOICE_LIST: `${baseUrl}/api/bszb/finance/invoice/list`, // 开票记录
  GET_INVOICE_MY: `${baseUrl}/api/bszb/finance/invoice/my`, // 我的开票申请
  GET_INVOICE_CHECK: `${baseUrl}/api/bszb/finance/invoice/my/check`, // 我的开票审核
  GET_INVOICE_STATIC_ORG: `${baseUrl}/api/bszb/finance/invoice/statisticByOrg`, // 开票统计按单位
  GET_INVOICE_STATIC_INCUBATOR: `${baseUrl}/api/bszb/finance/invoice/statisticByIncubator`, // 开票统计按孵化器
  GET_INVOICE_RECORD_ORG: `${baseUrl}/api/bszb/finance/invoice/listByOrg`, // 开票记录按单位
  GET_INVOICE_INFO: `${baseUrl}/api/bszb/finance/invoice/info`, // 开票详情
  FINANCE_INVOICE_SAVE: `${baseUrl}/api/bszb/finance/invoice/save`, // 开票保存
  FINANCE_INVOICE_DELETE: `${baseUrl}/api/bszb/finance/invoice/delete`, // 开票删除
  FINANCE_INVOICE_NEXT: `${baseUrl}/api/bszb/finance/invoice/nextActivity`, // 流程审核
  FINANCE_INVOICE_RETURN: `${baseUrl}/api/bszb/finance/invoice/returnActivity`, // 开票流程打回
  FINANCE_INVOICE_CALLBACK: `${baseUrl}/api/bszb/finance/invoice/callbackActivity`, // 开票流程收回
  FINANCE_INVOICE_WORKFLOW: `${baseUrl}/api/bszb/finance/invoice/workflow`, // 开票流程申请流程
  FINANCE_INVOICE_INVALID: `${baseUrl}/api/bszb/finance/invoice/invalid`, // 发票作废

  //* *******************分摊*****************************
  GET_APPORTION_ORIGIN: `${baseUrl}/api/bszb/finance/budget/apportion/origin`, // 预算分摊来源
  GET_APPORTION_LIST: `${baseUrl}/api/bszb/finance/budget/apportion/list`, // 分摊列表
  GET_APPORTION_INFO: `${baseUrl}/api/bszb/finance/budget/apportion/info`, // 分摊列表
  SAVE_APPORTION: `${baseUrl}/api/bszb/finance/budget/apportion/save`, // 分摊保存
  SAVE_APPORTION_DETAIL: `${baseUrl}/api/bszb/finance/budget/apportion/save/detail`, // 分摊保存
  APPORTION_DELETE_DETAIL: `${baseUrl}/api/bszb/finance/budget/apportion/delete/detail`, // 分摊方案明细删除
  APPORTION_CHECK_DETAIL: `${baseUrl}/api/bszb/finance/budget/apportion/detail/check`, // 分摊方案明细审核
  APPORTION_ISPUBLIC: `${baseUrl}/api/bszb/finance/budget/apportion/isPublic`, // 资金类型是否可以公摊
  APPORTION_DELETE: `${baseUrl}/api/bszb/finance/budget/apportion/delete`, // 分摊方案删除
  APPORTION_TONO: `${baseUrl}/api/bszb/finance/budget/apportion/no`, // 不分摊
  APPORTION_TORESTORE: `${baseUrl}/api/bszb/finance/budget/apportion/restore`, // 恢复分摊

  // ********************公司账户信息****************
  GET_BOOKINFO_LIST: `${baseUrl}/api/bszb/finance/bookInfo/list`, // 公司账户信息列表
  GET_BOOKINFO_INFO: `${baseUrl}/api/bszb/finance/bookInfo/info`, // 公司账户信息详情
  SAVE_BOOKINFO: `${baseUrl}/api/bszb/finance/bookInfo/save`, // 保存公司账户信息
  DELETE_BOOKINFO: `${baseUrl}/api/bszb/finance/bookInfo/delete`, // 删除公司账户信息
  ABLE_BOOKINFO: `${baseUrl}/api/bszb/finance/bookInfo/able`, // 启用禁用公司账户信息

  // ********************公司回单卡记录****************
  GET_RECEIPT_LIST: `${baseUrl}/api/bszb/finance/receipt/list`, // 公司回单卡记录列表
  GET_RECEIPT_INFO: `${baseUrl}/api/bszb/finance/receipt/info`, // 公司回单卡记录详情
  SAVE_RECEIPT: `${baseUrl}/api/bszb/finance/receipt/save`, // 保存公司回单卡记录
  DELETE_RECEIPT: `${baseUrl}/api/bszb/finance/receipt/delete`, // 删除公司回单卡记录
  ABLE_RECEIPT: `${baseUrl}/api/bszb/finance/receipt/able`, // 启用禁用公司回单卡记录
  IMPORT_RECEIPT: `${baseUrl}/api/bszb/finance/receipt/import`, // 导入公司回单卡记录
  DOWNLOAD_RECEIPT_TEMPLATE: `${baseUrl}/api/bszb/finance/receipt/template`, // 导入公司回单卡记录
};
export const xxcrm = {
  //* ***********************合同******************************
  CONTRACT_LIST: `${baseUrl}/api/contract/list`, // 获取合同列表,
  CONTRACT_LOG: `${baseUrl}/api/contract/log/list`, // 获取操作日志,
  CONTRACT_SAVE: `${baseUrl}/api/contract/save`, // 添加合同,
  CONTRACT_BATCHSAVE: `${baseUrl}/api/contract/batchSave`, // 批量添加合同,
  CONTRACT_DELETE: `${baseUrl}/api/contract/delete`, // 删除合同,
  CONTRACT_USE: `${baseUrl}/api/contract/use`, // 使用合同,
  CONTRACT_ALLOT: `${baseUrl}/api/contract/assignation`, // 分配合同,
  CONTRACT_TRANSFER: `${baseUrl}/api/contract/transfer`, // 转移合同,
  CONTRACT_INVALID: `${baseUrl}/api/contract/invalid`, // 作废合同,
  CONTRACT_LOST: `${baseUrl}/api/contract/lost`, // 遗失合同,
  CONTRACT_RESTORE: `${baseUrl}/api/contract/restore`, // 恢复合同,
  CONTRACT_RECYCLE: `${baseUrl}/api/contract/recycle`, // 回收合同,
  CONTRACT_APPLY_SAVE: `${baseUrl}/api/contract/apply/save`, // 合同申请,
  CONTRACT_APPLY_LIST: `${baseUrl}/api/contract/apply/list`, // 合同申请,
  CONTRACT_APPLY_ALLOT: `${baseUrl}/api/contract/apply/assignation`, // 分配合同申请的合同,
  CONTRACT_APPLY_MY: `${baseUrl}/api/contract/apply/my`, // 我的合同申请列表,
  CONTRACT_TYPE: `${baseUrl}/api/core/dict/contract/type/list`, // 合同类型列表
  CONTRACT_CHECK: `${baseUrl}/api/contract/check`, // 同意审核操作
  CONTRACT_REFUSE: `${baseUrl}/api/contract/refuse`, // 拒绝审核操作
  CONTRACT_EXPORT: `${baseUrl}/api/contract/export`, // 导出
  CONTRACT_TRANSFER_CONFIRM: `${baseUrl}/api/contract/transfer/confirm`, // 确认合同转移
  CONTRACT_TRANSFER_REFUSE: `${baseUrl}/api/contract/transfer/refuse`, // 拒绝合同转移
  //* ********************客户查询****************************
  CUSTOM_LIST: `${baseUrl}/api/xxcrm/customer/list`, // 客户查询
  //* ********************客户保护****************************
  CUSTOM_PROTECTION_LIST: `${baseUrl}/api/custom/protection/list`, // 保护的客户列表,
  CUSTOM_PROTECTION_HISTORY: `${baseUrl}/api/custom/protection/history`, // 保护的客户列表,
  CUSTOM_PROTECTION_SEARCH: `${baseUrl}/api/custom/protection/search`, // 保护客户查询,
  CUSTOM_PROTECTION_SAVE: `${baseUrl}/api/custom/protection/save`, // 添加客户保护,
  CUSTOM_PROTECTION_INFO: `${baseUrl}/api/custom/protection/info`, // 客户保护明细,
  CUSTOM_PROTECTION_RENEWAL: `${baseUrl}/api/custom/protection/renewal`, // 续保,
  CUSTOM_PROTECTION_CANCEL: `${baseUrl}/api/custom/protection/cancel`, // 取消续保,
  ORDER_LIST: `${baseUrl}/api/xxcrm/order/list`, // 订单列表,
  ORDER_INFO: `${baseUrl}/api/xxcrm/order/info`, // 订单明细,
  //* *******************发票管理*****************************
  INVOICE_LIST: `${baseUrl}/api/xxcrm/invoice/list`, // 发票列表,
  INVOICE_SAVE: `${baseUrl}/api/xxcrm/invoice/save`, // 发票添加,
  INVOICE_USE: `${baseUrl}/api/xxcrm/invoice/use`, // 发票使用,
  INVOICE_RESTORE: `${baseUrl}/api/xxcrm/invoice/restore`, // 发票恢复,
  INVOICE_INVALID: `${baseUrl}/api/xxcrm/invoice/invalid`, // 发票作废
  INVOICE_RED: `${baseUrl}/api/xxcrm/invoice/red`, // 发票冲红,
  INVOICE_EXPORT: `${baseUrl}/api/xxcrm/invoice/export`, // 发票导出,
  INVOICE_DELETE: `${baseUrl}/api/xxcrm/invoice/delete`, // 发票删除,
  INVOICE_USE_EDIT: `${baseUrl}/api/xxcrm/invoice/useEdit`,
};
// 项目管理
export const project = {
  GET_PROTECTION_LIST: `${baseUrl}/api/bszb/project/info/list`, // 项目列表
  GET_PROTECTION_INFO: `${baseUrl}/api/bszb/project/info/info`, // 项目详情
  AGREE_PROTECTION: `${baseUrl}/api/bszb/project/info/agree`, // 同意
  REFUSE_PROTECTION: `${baseUrl}/api/bszb/project/info/refuse`, // 拒绝
};
export const core = {
  /** 字典列表 */
  DICT_INVOICE_TYPE: `${baseUrl}/api/core/dict/invoice/type`, // 合同详情
  DICT_INVOICE_CONTENT: `${baseUrl}/api/core/dict/invoice/content`, // 获取开票内容
  DICT_ICHAPTERAPP_TYPE: `${baseUrl}/api/core/dict/administrative/ichapterapp/type`, // 获取用章类别
  DICT_GLOBAL_CONFIG: `${baseUrl}/api/core/dict/global/config/type`, // 系统配置选项
  DICT_INDUSTRY_LIST: `${baseUrl}/api/core/dict/industry/list`, // 获取行业,
  DICT_BUDGET_TYPE: `${baseUrl}/api/core/dict/budget/type/budget`, // 获取预算收入类别,
  DICT_MATERIAL_DOCUMENT_TYPE: `${baseUrl}/api/core/dict/administrative/material/document/type`, // 资料类别

  GET_DICT_LIST_TREE: `${baseUrl}/api/core/dict/listTree`, // 字典列表,
  GET_DICT_INFO: `${baseUrl}/api/core/dict/info`, // 字典详情,
  DELETE_DICT: `${baseUrl}/api/core/dict/delete`, // 删除字典,
  SAVE_DICT: `${baseUrl}/api/core/dict/save`, // 保存字典,

  GET_FUNCTION_LIST_TREE: `${baseUrl}/api/core/function/listTree`, // 菜单栏列表,
  GET_FUNCTION_LIST_TREE_ENABLE: `${baseUrl}/api/core/function/listTree/enable`, // 菜单栏列表,
  GET_MY_FUNCTION_LIST_TREE: `${baseUrl}/api/core/function/myTree`, // 菜单栏列表,
  GET_FUNCTION_INFO: `${baseUrl}/api/core/function/info`, // 菜单栏详情,
  DELETE_FUNCTION: `${baseUrl}/api/core/function/delete`, // 删除菜单栏,
  SAVE_FUNCTION: `${baseUrl}/api/core/function/save`, // 保存菜单栏,
  GET_ROLE_LIST_ALL: `${baseUrl}/api/core/role/list/all`, // 角色列表,
  GET_ROLE_LIST: `${baseUrl}/api/core/role/list`, // 角色列表,
  GET_ROLE_INFO: `${baseUrl}/api/core/role/info`, // 角色详情,
  DELETE_ROLE: `${baseUrl}/api/core/role/delete`, // 删除角色,
  SAVE_ROLE: `${baseUrl}/api/core/role/save`, // 保存角色,
  SAVE_ROLE_FUNCTION: `${baseUrl}/api/core/role/function/save`, // 保存角色与菜单栏的关联,
  SAVE_BY_ROLE_ACCOUNT_ROLE: `${baseUrl}/api/core/account/role/saveByRole`, // 保存角色与用户关联,
  SAVE_BY_ACCOUNT_ACCOUNT_ROLE: `${baseUrl}/api/core/account/role/saveByAccount`, // 保存角色与用户关联,
  GET_ACCOUNT_ROLE_ACCOUNTS: `${baseUrl}/api/core/account/role/accounts`, // 获取角色关联的用户
  GET_ACCOUNT_ROLE_ROLES: `${baseUrl}/api/core/account/role/roles`, // 获取用户关联的角色,

  SAVE_BY_ACCOUNT_ACCOUNT_ORG: `${baseUrl}/api/core/account/org/saveByAccount`, // 保存角色与用户关联,
  GET_ACCOUNT_ORG_ORGS: `${baseUrl}/api/core/account/org/orgs`,

  GET_ROLE_FUNCTION_FUNCTIONLIST: `${baseUrl}/api/core/role/function/functionList`, // 保存角色,
  GET_ROLE_FUNCTION_ROLELIST: `${baseUrl}/api/core/role/function/roleList`, // 保存角色,

  //* *******************组织加用户列表*****************************
  ALL_USER_ORG_TREE: `${baseUrl}/api/core/account/tree`,

  //* *******************用户管理*****************************
  ACCOUNT_LIST: `${baseUrl}/api/core/account/list`, // 用户列表,
  CORE_ACCOUNT_UPDATE_PWD: `${baseUrl}/api/core/account/updatePwd`, // 修改用户密码,
  ROLE_LIST: `${baseUrl}/api/core/account/role/list`, // 用户列表,
  ACCOUNT_INFO: `${baseUrl}/api/core/account/info`, // 获取登录人的信息,
  USER_ORG_TREE: `${baseUrl}/api/core/account/orgTree`, // 用户列表,
  CORE_ACCOUNT_SEARCH: `${baseUrl}/api/core/account/search`, // 用户列表根据用户名搜索,
  GET_ADMIN_ACCOUNT_LIST: `${baseUrl}/api/core/account/admin/list`, // 用户列表（管理员)
  GET_ADMIN_ACCOUNT_INFO: `${baseUrl}/api/core/account/admin/info`, // 用户列表（管理员)
  SAVE_ACCOUNT: `${baseUrl}/api/core/account/save`, // 用户保存
  //* *******************组织管理*****************************
  CORE_ORG_LIST: `${baseUrl}/api/core/org/list`, // 组织列表,
  ORG_LIST_ALL: `${baseUrl}/api/core/org/list/all`, // 所有组织列表,
  XX_ORG_LIST: `${baseUrl}/api/core/org/xianxing`,
  CORE_ORG_COMPANY_LIST: `${baseUrl}/api/core/org/company/list`, // 获取组织列表,
  // 组织管理
  CORE_ORG_TREE: `${baseUrl}/api/core/org/tree`, // 获取组织的树状列表
  CORE_BY_ORG_TREE: `${baseUrl}/api/core/org/treeByOrg`, // 获取组织的树状列表
  ORG_INFO: `${baseUrl}/api/core/org/info`, // 获取组织的详情
  CORE_ORG_ENABLE_TREE: `${baseUrl}/api/core/org/enable/tree`, // 获取组织的启用树状列表
  CORE_ORG_ADD: `${baseUrl}/api/core/org/add`, // 新增组织架构
  CORE_ORG_UPDATE: `${baseUrl}/api/core/org/update`, // 更新组织
  CORE_ORG_DELETE: `${baseUrl}/api/core/org/delete`, // 组织删除
  CORE_ORG_DISABLE: `${baseUrl}/api/core/org/disable`, // 组织禁用
  CORE_ORG_ENABLE: `${baseUrl}/api/core/org/enable`, // 组织启用
  CORE_ORG_MOVE: `${baseUrl}/api/core/org/move`, // 组织移动
  GET_CUISTOM_CATEGORY: `${baseUrl}/api/core/dict/crm/custom/category`, // 行业分类1
  GET_CUISTOM_FIELD: `${baseUrl}/api/core/dict/crm/custom/field`, // 客户可以显示的字段

  FINANCE_DICT_INCOME: `${baseUrl}/api/core/dict/income/type/income`, // 收入类别
  FINANCE_DICT_EXPEND: `${baseUrl}/api/core/dict/income/type/expenditure`, // 支出类别

  GET_GLOBAL_CONFIG_LIST: `${baseUrl}/api/core/global/config/list`, // 字典列表,
  GET_GLOBAL_CONFIG_CONFIG: `${baseUrl}/api/core/global/config/config`, // 已经配置的字典选项,
  GET_GLOBAL_CONFIG_INFO: `${baseUrl}/api/core/global/config/info`, // 字典详情,
  DELETE_GLOBAL_CONFIG: `${baseUrl}/api/core/global/config/delete`, // 删除字典,
  SAVE_GLOBAL_CONFIG: `${baseUrl}/api/core/global/config/save`, // 保存字典,

  // ********************公司账户信息****************
  GET_SERIALNUMBER_LIST: `${baseUrl}/api/core/serialNumber/list`, // 公司账户信息列表
  GET_SERIALNUMBER_INFO: `${baseUrl}/api/core/serialNumber/info`, // 公司账户信息详情
  SAVE_SERIALNUMBER: `${baseUrl}/api/core/serialNumber/save`, // 保存公司账户信息
  DELETE_SERIALNUMBER: `${baseUrl}/api/core/serialNumber/delete`, // 删除公司账户信息
};

export const administrative = {
  /* ----------------------material----------------------------------------------------------------------------------*/
  //* *******************资料管理*****************************
  MATERIAL_DIRECTORY_LIST: `${baseUrl}/api/bszb/administrative/material/directory/list`, // 资料目录列表
  MATERIAL_DIRECTORY_INFO: `${baseUrl}/api/bszb/administrative/material/directory/info`, // 资料目录详情
  MATERIAL_DIRECTORY_SAVE: `${baseUrl}/api/bszb/administrative/material/directory/save`, // 资料目录保存
  MATERIAL_DIRECTORY_DELETE: `${baseUrl}/api/bszb/administrative/material/directory/delete`, // 资料目录删除

  MATERIAL_DATABASE_LIST: `${baseUrl}/api/bszb/administrative/material/database/list`, // 资料库列表
  MATERIAL_DATABASE_LIST_BR: `${baseUrl}/api/bszb/administrative/material/database/listByReader`, // 我可查阅的资料库列表
  MATERIAL_DATABASE_LIST_BM: `${baseUrl}/api/bszb/administrative/material/database/listByManager`, // 我负责的资料库列表
  MATERIAL_DATABASE_INFO: `${baseUrl}/api/bszb/administrative/material/database/info`, // 资料库详情
  MATERIAL_DATABASE_SAVE: `${baseUrl}/api/bszb/administrative/material/database/save`, // 资料库保存
  MATERIAL_DATABASE_DELETE: `${baseUrl}/api/bszb/administrative/material/database/delete`, // 资料库删除
  MATERIAL_DATABASE_TYPE: `${baseUrl}/api/bszb/administrative/material/database/type`, // 资料库类型

  MATERIAL_DOCUMENT_LIST: `${baseUrl}/api/bszb/administrative/material/document/list`, // 资料文档列表
  MATERIAL_DOCUMENT_LIST_BR: `${baseUrl}/api/bszb/administrative/material/document/listByReader`, // 我可查阅的资料列表
  MATERIAL_DOCUMENT_LIST_BM: `${baseUrl}/api/bszb/administrative/material/document/listByManager`, // 我负责的资料列表
  MATERIAL_DOCUMENT_MY: `${baseUrl}/api/bszb/administrative/material/document/my`, // 我的资料文档列表
  MATERIAL_DOCUMENT_INFO: `${baseUrl}/api/bszb/administrative/material/document/info`, // 资料文档详情
  MATERIAL_DOCUMENT_SAVE: `${baseUrl}/api/bszb/administrative/material/document/save`, // 资料文档保存
  MATERIAL_DOCUMENT_DELETE: `${baseUrl}/api/bszb/administrative/material/document/delete`, // 资料文档删除
  MATERIAL_DOCUMENT_LOG: `${baseUrl}/api/bszb/administrative/material/document/log`, // 资料文档操作日志
  //* *******************资料借用*****************************
  GET_MATERIAL_BORROW_LIST: `${baseUrl}/api/bszb/administrative/material/borrow/list`, // 资料借用记录
  GET_MATERIAL_BORROW_MY: `${baseUrl}/api/bszb/administrative/material/borrow/my`, // 我的资料借用申请
  GET_MATERIAL_BORROW_CHECK: `${baseUrl}/api/bszb/administrative/material/borrow/my/check`, // 我的资料借用审核
  GET_MATERIAL_BORROW_INFO: `${baseUrl}/api/bszb/administrative/material/borrow/info`, // 资料借用详情
  MATERIAL_BORROW_SAVE: `${baseUrl}/api/bszb/administrative/material/borrow/save`, // 资料借用保存
  MATERIAL_BORROW_DELETE: `${baseUrl}/api/bszb/administrative/material/borrow/delete`, // 资料借用删除
  MATERIAL_BORROW_NEXT: `${baseUrl}/api/bszb/administrative/material/borrow/nextActivity`, // 流程审核
  MATERIAL_BORROW_RETURN: `${baseUrl}/api/bszb/administrative/material/borrow/returnActivity`, // 资料借用流程打回
  MATERIAL_BORROW_CALLBACK: `${baseUrl}/api/bszb/administrative/material/borrow/callbackActivity`, // 资料借用流程收回
  MATERIAL_BORROW_WORKFLOW: `${baseUrl}/api/bszb/administrative/material/borrow/workflow`, // 资料借用流程申请流程
  //* *******************资料归还*****************************
  GET_MATERIAL_RETURN_LIST: `${baseUrl}/api/bszb/administrative/material/return/list`, // 资料归还记录
  GET_MATERIAL_RETURN_LIST_TODO: `${baseUrl}/api/bszb/administrative/material/return/list/todo`, // 资料归还记录
  GET_MATERIAL_RETURN_LIST_DONE: `${baseUrl}/api/bszb/administrative/material/return/list/done`, // 资料归还记录
  GET_MATERIAL_RETURN_BR: `${baseUrl}/api/bszb/administrative/material/return/my`, // 我的资料归还
  GET_MATERIAL_RETURN_BR_TODO: `${baseUrl}/api/bszb/administrative/material/return/my/todo`, // 我的资料待归还
  GET_MATERIAL_RETURN_BR_DONE: `${baseUrl}/api/bszb/administrative/material/return/my/done`, // 我的资料已归还
  GET_MATERIAL_RETURN_BM: `${baseUrl}/api/bszb/administrative/material/return/listByManager`, // 我管理的资料归还
  GET_MATERIAL_RETURN_BM_TODO: `${baseUrl}/api/bszb/administrative/material/return/listByManager/todo`, // 我管理的资料待归还
  GET_MATERIAL_RETURN_BM_DONE: `${baseUrl}/api/bszb/administrative/material/return/listByManager/done`, // 我管理的资料已归还
  MATERIAL_RETURN_SAVE: `${baseUrl}/api/bszb/administrative/material/return/save`, // 资料归还保存

  //* *******************资料续证*****************************
  GET_MATERIAL_RENEWAL_MY: `${baseUrl}/api/bszb/administrative/material/renewal/my`, // 我的资料续证
  GET_MATERIAL_RENEWAL_LIST: `${baseUrl}/api/bszb/administrative/material/renewal/list`, // 资料续证监控
  GET_MATERIAL_RENEWAL_INFO: `${baseUrl}/api/bszb/administrative/material/renewal/info`, // 资料续证详情
  MATERIAL_RENEWAL_SAVE: `${baseUrl}/api/bszb/administrative/material/renewal/save`, // 保存资料续证
  MATERIAL_RENEWAL_DELETE: `${baseUrl}/api/bszb/administrative/material/renewal/delete`, // 资料续证删除
  MATERIAL_RENEWAL_NEXT: `${baseUrl}/api/bszb/administrative/material/renewal/nextActivity`, // 流程审核
  MATERIAL_RENEWAL_NEXT_UPLOAD: `${baseUrl}/api/bszb/administrative/material/renewal/nextActivityUpload`, // 资料续证上传相关附件
  MATERIAL_RENEWAL_NEXT_SCAN: `${baseUrl}/api/bszb/administrative/material/renewal/nextActivityScan`, // 流程提交扫描件
  MATERIAL_RENEWAL_NEXT_ARCHIVE: `${baseUrl}/api/bszb/administrative/material/renewal/nextActivityArchive`, // 流程行政归档
  MATERIAL_RENEWAL_RETURN: `${baseUrl}/api/bszb/administrative/material/renewal/returnActivity`, // 资料续证流程打回
  MATERIAL_RENEWAL_CALLBACK: `${baseUrl}/api/bszb/administrative/material/renewal/callbackActivity`, // 资料续证流程收回
  MATERIAL_RENEWAL_WORKFLOW: `${baseUrl}/api/bszb/administrative/material/renewal/workflow`, // 资料续证流程申请流程
  //* *******************用章*****************************
  GET_SEAL_LIST: `${baseUrl}/api/bszb/administrative/ichapterapp/list`, // 用章记录
  GET_SEAL_MY: `${baseUrl}/api/bszb/administrative/ichapterapp/my`, // 我的用章申请
  GET_SEAL_CHECK: `${baseUrl}/api/bszb/administrative/ichapterapp/my/check`, // 我的用章审核
  GET_SEAL_STATIC_ORG: `${baseUrl}/api/bszb/administrative/ichapterapp/statisticByOrg`, // 用章统计按单位
  GET_SEAL_STATIC_INCUBATOR: `${baseUrl}/api/bszb/administrative/ichapterapp/statisticByIncubator`, // 用章统计按孵化器
  GET_SEAL_RECORD_ORG: `${baseUrl}/api/bszb/administrative/ichapterapp/listByOrg`, // 用章记录按单位
  GET_SEAL_INFO: `${baseUrl}/api/bszb/administrative/ichapterapp/info`, // 用章详情
  SEAL_SAVE: `${baseUrl}/api/bszb/administrative/ichapterapp/save`, // 用章保存
  SEAL_DELETE: `${baseUrl}/api/bszb/administrative/ichapterapp/delete`, // 用章删除
  SEAL_NEXT: `${baseUrl}/api/bszb/administrative/ichapterapp/nextActivity`, // 流程审核
  SEAL_NEXT_SCAN: `${baseUrl}/api/bszb/administrative/ichapterapp/nextActivityScan`, // 流程提交扫描件
  SEAL_NEXT_ARCHIVE: `${baseUrl}/api/bszb/administrative/ichapterapp/nextActivityArchive`, // 流程行政归档
  SEAL_RETURN: `${baseUrl}/api/bszb/administrative/ichapterapp/returnActivity`, // 用章流程打回
  SEAL_CALLBACK: `${baseUrl}/api/bszb/administrative/ichapterapp/callbackActivity`, // 用章流程收回
  SEAL_WORKFLOW: `${baseUrl}/api/bszb/administrative/ichapterapp/workflow`, // 用章流程申请流程

  //* *******************采购*****************************
  GET_PURCHASE_LIST: `${baseUrl}/api/bszb/administrative/purchase/list`, // 采购记录
  GET_PURCHASE_MY: `${baseUrl}/api/bszb/administrative/purchase/my`, // 我的采购申请
  GET_PURCHASE_CHECK: `${baseUrl}/api/bszb/administrative/purchase/my/check`, // 我的采购审核
  GET_PURCHASE_STATIC_ORG: `${baseUrl}/api/bszb/administrative/purchase/statisticByOrg`, // 采购统计按单位
  GET_PURCHASE_STATIC_INCUBATOR: `${baseUrl}/api/bszb/administrative/purchase/statisticByIncubator`, // 采购统计按孵化器
  GET_PURCHASE_RECORD_ORG: `${baseUrl}/api/bszb/administrative/purchase/listByOrg`, // 采购记录按单位
  GET_PURCHASE_INFO: `${baseUrl}/api/bszb/administrative/purchase/info`, // 采购详情
  PURCHASE_SAVE: `${baseUrl}/api/bszb/administrative/purchase/save`, // 采购保存
  PURCHASE_DELETE: `${baseUrl}/api/bszb/administrative/purchase/delete`, // 采购删除
  PURCHASE_NEXT: `${baseUrl}/api/bszb/administrative/purchase/nextActivity`, // 流程审核
  PURCHASE_TRANSFER: `${baseUrl}/api/bszb/administrative/purchase/transfer`, // 流程转移
  PURCHASE_RETURN: `${baseUrl}/api/bszb/administrative/purchase/returnActivity`, // 采购流程打回
  PURCHASE_CALLBACK: `${baseUrl}/api/bszb/administrative/purchase/callbackActivity`, // 采购流程收回
  PURCHASE_WORKFLOW: `${baseUrl}/api/bszb/administrative/purchase/workflow`, // 采购流程申请流程

  // ********************公告列表****************
  GET_ANNOUNCEMENT_LIST: `${baseUrl}/api/bszb/administrative/announcement/list`, // 公告列表列表
  GET_ANNOUNCEMENT_INFO: `${baseUrl}/api/bszb/administrative/announcement/info`, // 公告列表详情
  SAVE_ANNOUNCEMENT: `${baseUrl}/api/bszb/administrative/announcement/save`, // 保存公告列表
  DELETE_ANNOUNCEMENT: `${baseUrl}/api/bszb/administrative/announcement/delete`, // 删除公告列表
};

export const workflow = {
  WORKFLOW_TEMPLATE_LIST: `${baseUrl}/api/bszb/workflow/template/list`, // 工作流模板列表
  WORKFLOW_TEMPLATE_INFO: `${baseUrl}/api/bszb/workflow/template/info`, // 工作流模板详情
  WORKFLOW_TEMPLATE_SAVE: `${baseUrl}/api/bszb/workflow/template/save`, // 工作流模板保存
  WORKFLOW_TEMPLATE_DELETE: `${baseUrl}/api/bszb/workflow/template/delete`, // 工作流模板删除
  GET_TASK_LIST: `${baseUrl}/api/bszb/workflow/instance/message/todo`, // 所有待办
  GET_DONE_TASK_LIST: `${baseUrl}/api/bszb/workflow/instance/message/done`, // 所有已办
  GET_PAYROLL: `${baseUrl}/api/bszb/workflow/instance/message/payroll`, // 工资单
};

export const common = {
  LOGIN: `${baseUrl}/api/core/account/login`, // 登陆
  UPLOAD: `${baseUrl}/api/pub/attachment/uploads`, // 上传附件
  READONLINE: `${baseUrl}/api/pub/attachment/readOnline`, // 文件预览
  CORE_ORG_CONFIG: `${baseUrl}/api/pub/org/config/save`, // 获取组织的树状列表
  CORE_ORG_CONFIG_OPTIONS: `${baseUrl}/api/pub/org/config/options`, // 组织人员可配置选项
  PUP_ORG_CONFIG_INFO: `${baseUrl}/api/pub/org/config/info`, // 组织人员可配置选项

  // 评论模块
  TALK_LIST: `${baseUrl}/api/bszb/common/talk/list`, // 评论列表
  TALK_SAVE: `${baseUrl}/api/bszb/common/talk/save`, // 发布评论
  /** 合同模块 */
  BUSINESS_INFO: `${baseUrl}/api/bszb/common/business/info`, // 合同详情
  BUSINESS_LOG: `${baseUrl}/api/bszb/common/log/list`, // 合同操作日志

  /** 客户模块 */
  CUSTOM_ACCOUNT_SAVE: `${baseUrl}/api/bszb/common/custom/account/save`, // 客户帐号信息保存
  CUSTOM_SAVE: `${baseUrl}/api/bszb/common/custom/save`, // 客户帐号信息
  /** 附件管理 */
  ATTCHMENT_SAVE: `${baseUrl}/api/pub/attachment/save`, // 文件上传
  ATTCHMENT_DELETE: `${baseUrl}/api/pub/attachment/delete`, // 文件删除
  FILE_LIST: `${baseUrl}/api/pub/attachment/list`, // 文件列表
};

export const crm = {
  /* ----------------------客户模块----------------------------------------------------------------------------------*/
  GET_CUSTOM_LIST: `${baseUrl}/api/bszb/crm/custom/list`, // 客户列表
  GET_CUSTOM_INFO: `${baseUrl}/api/bszb/crm/custom/info`, // 客户详情
  GET_CUSTOM_DEPARTMENT_DISTRIBUTION_LIST: `${baseUrl}/api/bszb/crm/custom/department/distribution/list`, // 分属部门分配情况
  CUSTOM_DEPARTMENT_DISTRIBUTION_SAVE: `${baseUrl}/api/bszb/crm/custom/department/distribution/save`, // 保存分属部门分配情况
  GET_DEPARTMENT_MY: `${baseUrl}/api/bszb/crm/department/my`, // 当前用户所在的分属部门详情
  GET_CUSTOM_DEPARTMENT_LIST: `${baseUrl}/api/bszb/crm/custom/department/list`, // 分属客户列表
  GET_CUSTOM_DEPARTMENT_INFO: `${baseUrl}/api/bszb/crm/custom/department/info`, // 分属客户详情
  CUSTOM_SAVE: `${baseUrl}/api/bszb/crm/custom/save`, // 客户保存
  CUSTOM_DEPARTMENT_SAVE: `${baseUrl}/api/bszb/crm/custom/department/save`, // 分属部门客户保存
  GET_CUSTOM_PROTECTION_LIST: `${baseUrl}/api/bszb/crm/custom/protection/list`, // 客户保存列表
  GET_CUSTOM_PROTECTION_MY_LIST: `${baseUrl}/api/bszb/crm/custom/protection/my/list`, // 个人客户保存列表
  CUSTOM_PROTECTION_SAVE: `${baseUrl}/api/bszb/crm/custom/protection/save`, // 客户保护
  CUSTOM_PROTECTION_DISTRIBUTION_SAVE: `${baseUrl}/api/bszb/crm/custom/protection/distribution/save`, // 客户保存分配
  CUSTOM_PROTECTION_CANCEL: `${baseUrl}/api/bszb/crm/custom/protection/cancel`, // 取消客户保护
  GET_CUSTOM_CONTACT_LIST: `${baseUrl}/api/bszb/crm/custom/contact/list`, // 客户联系记录列表
  CUSTOM_CONTACT_SAVE: `${baseUrl}/api/bszb/crm/custom/contact/save`, // 联系记录保存
  CUSTOM_CONTACT_VERIFY: `${baseUrl}/api/bszb/crm/custom/contact/verify`, // 联系记录保存
  GET_CLUE_LIST: `${baseUrl}/api/bszb/crm/clue/list`, // 线索列表
  CLUE_SAVE: `${baseUrl}/api/bszb/crm/clue/save`, // 线索保存
  GET_CLUE_INFO: `${baseUrl}/api/bszb/crm/clue/info`, // 线索详情
  CLUE_IMPORT: `${baseUrl}/api/bszb/crm/clue/import`, // 导入线索
  DOWNLOAD_CLUE_TEMPLATE: `${baseUrl}/api/bszb/crm/clue/template`, // 模线索板下载
  GET_DEPARTMENT_LIST: `${baseUrl}/api/bszb/crm/department/list`, // 分属部门列表
  GET_DEPARTMENT_SAVE: `${baseUrl}/api/bszb/crm/department/save`, // 分属部门列表
  DEPARTMENT_OPPORTUNITY_SAVE: `${baseUrl}/api/bszb/crm/department/opportunity/save`, // 分属部门的商机阶段设置
  DEPARTMENT_OPPORTUNITY_INFO: `${baseUrl}/api/bszb/crm/department/opportunity/info`, // 分属部门的商机阶段设置详情
  DEPARTMENT_PRODUCT_SAVE: `${baseUrl}/api/bszb/crm/department/product/save`, // 分属部门的产品设置
  DEPARTMENT_PRODUCT_INFO: `${baseUrl}/api/bszb/crm/department/product/info`, // 分属部门的产品设置详情
  DEPARTMENT_PROTECTION_SAVE: `${baseUrl}/api/bszb/crm/department/protection/save`, // 分属部门的客户保护设置保存
  DEPARTMENT_PROTECTION_INFO: `${baseUrl}/api/bszb/crm/department/protection/info`, // 分属部门的客户保护设置保存
  CUISTOM_VIEW_SAVE: `${baseUrl}/api/bszb/crm/department/custom/view/save`, // 分属部门的客户显示字段设置
  GET_CUISTOM_VIEW: `${baseUrl}/api/bszb/crm/department/custom/view/info`, // 分属部门的客户显示字段设置明细

  OPPORTUNITY_SAVE: `${baseUrl}/api/bszb/crm/opportunity/save`, // 商机保存
  GET_OPPORTUNITY_LIST: `${baseUrl}/api/bszb/crm/opportunity/my/list`, // 商机列表
  GET_OPPORTUNITY_INFO: `${baseUrl}/api/bszb/crm/opportunity/info`, // 商机列表
};
export const incubator = {
  /** 基础管理 */
  INCUBATOR_BASE_LIST: `${baseUrl}/api/bszb/incubator/base/list`, // 孵化器地址列表
  INCUBATOR_BASE_INFO: `${baseUrl}/api/bszb/incubator/base/info`, // 孵化器地址详情
  INCUBATOR_BASE_SAVE: `${baseUrl}/api/bszb/incubator/base/save`, // 孵化器地址编辑
  INCUBATOR_BASE_INCOME: `${baseUrl}/api/bszb/incubator/base/income/record`, // 孵化器资金列表
  INCUBATOR_BASE_REFUND_TODO: `${baseUrl}/api/bszb/incubator/custom/finance/income/refund/todo`, // 孵化器待退款资金列表

  /** 文件关联 */
  INCUBATOR_DATEBASE_SAVE: `${baseUrl}/api/bszb/incubator/database/relate/save`, // 文件关联
  INCUBATOR_DATEBASE_DElETE: `${baseUrl}/api/bszb/incubator/database/relate/delete`, // 删除文件关联

  /** 地址 */
  INCUBATOR_ADDRESS_LIST: `${baseUrl}/api/bszb/incubator/address/list`, // 孵化器地址列表
  INCUBATOR_ADDRESS_INFO: `${baseUrl}/api/bszb/incubator/address/info`, // 孵化器地址详情
  INCUBATOR_ADDRESS_BATCH: `${baseUrl}/api/bszb/incubator/address/batch`, // 孵化器地址新增
  INCUBATOR_ADDRESS_SAVE: `${baseUrl}/api/bszb/incubator/address/save`, // 孵化器地址编辑
  INCUBATOR_ADDRESS_DELETE: `${baseUrl}/api/bszb/incubator/address/delete`, // 孵化器地址删除
  INCUBATOR_ADDRESS_STATISTIC: `${baseUrl}/api/bszb/incubator/address/statistic`, // 孵化器地址统计
  INCUBATOR_ADDRESS_COUNT: `${baseUrl}/api/bszb/incubator/address/count`, // 孵化器地址总数
  ADDRESS_BUSINESS_LIST: `${baseUrl}/api/bszb/incubator/address/business/list`, // 地址使用情况
  ADDRESS_BUSINESS_STATIS: `${baseUrl}/api/bszb/incubator/address/business/statistics`, // 合同使用情况统计
  ADDRESS_BUSINESS_LIBERATE: `${baseUrl}/api/bszb/incubator/address/liberate`, // 地址释放

  /** 工位 */
  INCUBATOR_STATION_CONFIG: `${baseUrl}/api/bszb/incubator/station/config/save`, // 孵化器工位设置
  INCUBATOR_STATION_ADD: `${baseUrl}/api/bszb/incubator/station/add`, // 新增工位
  INCUBATOR_STATION_CONFIG_INFO: `${baseUrl}/api/bszb/incubator/station/config/info`, // 孵化器工位设置详情
  INCUBATOR_STATION_SAVE: `${baseUrl}/api/bszb/incubator/station/add`, // 孵化器工位详情
  INCUBATOR_STATION_LIST: `${baseUrl}/api/bszb/incubator/station/list`, // 孵化器工位列表
  INCUBATOR_STATION_DELETE: `${baseUrl}/api/bszb/incubator/station/delete`, // 删减工位
  INCUBATOR_STATION_ENABLE: `${baseUrl}/api/bszb/incubator/station/enable`, // 启用工位
  INCUBATOR_STATION_DISABLE: `${baseUrl}/api/bszb/incubator/station/disable`, // 禁用工位
  INCUBATOR_STATION_UNIT: `${baseUrl}/api/bszb/incubator/station/unit`, // 单价设置
  INCUBATOR_STATION_RESET: `${baseUrl}/api/bszb/incubator/station/reset`, // 重置工位设置
  INCUBATOR_STATION_COUNT: `${baseUrl}/api/bszb/incubator/station/count`, // 孵化器工位总数
  INCUBATOR_STATION_STATISTIC: `${baseUrl}/api/bszb/incubator/station/statistics`, // 工位统计

  /** 工位入驻 */
  INCUBATOR_SETTLED_LIST: `${baseUrl}/api/bszb/incubator/business/settled/list`, // 孵化器工位入驻记录
  INCUBATOR_SETTLED_MY: `${baseUrl}/api/bszb/incubator/business/settled/my`, // 我的孵化器工位入驻申请
  INCUBATOR_SETTLED_MY_CHECK: `${baseUrl}/api/bszb/incubator/business/settled/my/check`, // 我的孵化器工位入驻审核
  INCUBATOR_SETTLED_SAVE: `${baseUrl}/api/bszb/incubator/business/settled/save`, // 孵化器工位入驻保存
  INCUBATOR_SETTLED_DELETE: `${baseUrl}/api/bszb/incubator/business/settled/delete`, // 孵化器工位入驻删除
  INCUBATOR_SETTLED_INFO: `${baseUrl}/api/bszb/incubator/business/settled/info`, // 孵化器工位入驻详情
  INCUBATOR_SETTLED_NEXT: `${baseUrl}/api/bszb/incubator/business/settled/nextActivity`, // 流程审核
  INCUBATOR_SETTLED_NEXT_SCAN: `${baseUrl}/api/bszb/incubator/business/settled/nextActivityScan`, // 经办人提交文件扫描件
  INCUBATOR_SETTLED_NEXT_ARCHIVE: `${baseUrl}/api/bszb/incubator/business/settled/nextActivityArchive`, // 行政文件归档
  INCUBATOR_SETTLED_RETURN: `${baseUrl}/api/bszb/incubator/business/settled/returnActivity`, // 孵化器工位入驻流程打回
  INCUBATOR_SETTLED_CALLBACK: `${baseUrl}/api/bszb/incubator/business/settled/callbackActivity`, // 收回孵化器工位入驻流程
  INCUBATOR_SETTLED_WORKFLOW: `${baseUrl}/api/bszb/incubator/business/settled/workflow`, // 收回孵化器工位入驻流程
  SETTLED_WORKFLOW: `${baseUrl}/api/bszb/incubator/business/settled/discount`, // 折扣清单
  STATION_SETTLED_RELATE: `${baseUrl}/api/bszb/incubator/business/settled/relate`, // 手动入驻合同关联
  RENEW_SETTLED_INFO: `${baseUrl}/api/bszb/incubator/business/settled/renewStations`, // 获取需要续签合同工位列表以及新续签合同的开始时间

  /** 地址管理 */
  INCUBATOR_OREGISTAPP_LISTBYINC: `${baseUrl}/api/bszb/incubator/business/oregistapp/listByIncubator`, // 孵化器注册地址列表
  INCUBATOR_OREGISTAPP_LISTBYINC_EXPORT: `${baseUrl}/api/bszb/incubator/business/oregistapp/listByIncubator/export`, // 孵化器注册地址列表
  INCU_BUSINESS_REMIND_OREGISTAPP: `${baseUrl}/api/bszb/incubator/business/remind/oregistapp`, // 地址提醒
  INCU_BUSINESS_OVERDUE_OREGISTAPP: `${baseUrl}/api/bszb/incubator/business/overdue/oregistapp`, // 逾期地址

  /** 地址入驻 */
  INCUBATOR_OREGISTAPP_LIST: `${baseUrl}/api/bszb/incubator/business/oregistapp/list`, // 孵化器地址入驻记录
  INCUBATOR_OREGISTAPP_MY: `${baseUrl}/api/bszb/incubator/business/oregistapp/my`, // 我的孵化器地址入驻申请
  INCUBATOR_OREGISTAPP_MY_CHECK: `${baseUrl}/api/bszb/incubator/business/oregistapp/my/check`, // 我的孵化器地址入驻审核
  INCUBATOR_OREGISTAPP_SAVE: `${baseUrl}/api/bszb/incubator/business/oregistapp/save`, // 孵化器地址入驻保存
  INCUBATOR_OREGISTAPP_DELETE: `${baseUrl}/api/bszb/incubator/business/oregistapp/delete`, // 孵化器地址入驻删除
  INCUBATOR_OREGISTAPP_INFO: `${baseUrl}/api/bszb/incubator/business/oregistapp/info`, // 孵化器地址入驻详情
  INCUBATOR_OREGISTAPP_ISAPPLY: `${baseUrl}/api/bszb/incubator/business/oregistapp/isApply`, // 判断客户是否已经存在地址申请
  INCUBATOR_OREGISTAPP_NEXT: `${baseUrl}/api/bszb/incubator/business/oregistapp/nextActivity`, // 流程审核
  INCUBATOR_OREGISTAPP_RETURN: `${baseUrl}/api/bszb/incubator/business/oregistapp/returnActivity`, // 孵化器地址入驻流程打回
  INCUBATOR_OREGISTAPP_CALLBACK: `${baseUrl}/api/bszb/incubator/business/oregistapp/callbackActivity`, // 收回孵化器地址入驻流程
  INCUBATOR_OREGISTAPP_WORKFLOW: `${baseUrl}/api/bszb/incubator/business/oregistapp/workflow`, // 收回孵化器地址入驻流程
  ADDRESS_OREGISTAPP_RELATE: `${baseUrl}/api/bszb/incubator/business/oregistapp/relate`, // 手动入驻合同关联
  RENEW_OREGISTAPP_INFO: `${baseUrl}/api/bszb/incubator/business/oregistapp/renewAddresses`, // 获取需要续签合同地址列表以及新续签合同的开始时间

  /** 地址迁出 */
  INCUBATOR_OREGISTAPP_MOVE_OUT_LIST: `${baseUrl}/api/bszb/incubator/business/oregistapp/move/out/list`, // 孵化器地址迁出记录
  INCUBATOR_OREGISTAPP_MOVE_OUT_MY: `${baseUrl}/api/bszb/incubator/business/oregistapp/move/out/my`, // 我的孵化器地址迁出申请
  INCUBATOR_OREGISTAPP_MOVE_OUT_INFO: `${baseUrl}/api/bszb/incubator/business/oregistapp/move/out/info`, // 孵化器地址迁出详情
  INCUBATOR_OREGISTAPP_MOVE_OUT_SAVE: `${baseUrl}/api/bszb/incubator/business/oregistapp/move/out/save`, // 孵化器地址迁出保存
  INCUBATOR_OREGISTAPP_MOVE_OUT_NEXT: `${baseUrl}/api/bszb/incubator/business/oregistapp/move/out/nextActivity`, // 流程审核
  INCUBATOR_OREGISTAPP_MOVE_OUT_RETURN: `${baseUrl}/api/bszb/incubator/business/oregistapp/move/out/returnActivity`, // 孵化器地址迁出流程打回
  INCUBATOR_OREGISTAPP_MOVE_OUT_CALLBACK: `${baseUrl}/api/bszb/incubator/business/oregistapp/move/out/callbackActivity`, // 收回孵化器地址迁出流程
  INCUBATOR_OREGISTAPP_MOVE_OUT_WORKFLOW: `${baseUrl}/api/bszb/incubator/business/oregistapp/move/out/workflow`, // 收回孵化器地址迁出流程

  /** 客户 */
  CUSTOM_LIST: `${baseUrl}/api/bszb/incubator/custom/list`, // 孵化器客户列表
  CUSTOM_LIST_EXPORT: `${baseUrl}/api/bszb/incubator/custom/list/export`, // 孵化器客户列表导出
  CUSTOM_INFO: `${baseUrl}/api/bszb/incubator/custom/info`, // 客户详情
  CUSTOM_SETTLED: `${baseUrl}/api/bszb/incubator/custom/settled`, // 客户入驻工位
  CUSTOM_SETTLED_SIGN: `${baseUrl}/api/bszb/incubator/custom/business/settled/sign`, // 孵化器客户的生效在签工位合同
  CUSTOM_BUSINESS_SETTLED: `${baseUrl}/api/bszb/incubator/custom/business/settled`, // 孵化器客户的生效基础孵化合同
  CUSTOM_BUSINESS_OREGISTAPP: `${baseUrl}/api/bszb/incubator/custom/business/oregistapp`, // 孵化器客户的生效地址合同
  CUSTOM_PROJECT: `${baseUrl}/api/bszb/incubator/custom/project`, // 客户项目
  CUSTOM_INCOME_UNCONFIRMED: `${baseUrl}/api/bszb/incubator/custom/income/unconfirmed`, // 客户未确认资金列表
  CUSTOM_INCOME_LIST: `${baseUrl}/api/bszb/incubator/custom/income/list`, // 客户资金列表
  CUSTOM_PAYABLE_TOBETURNS: `${baseUrl}/api/bszb/incubator/custom/payable/toBeTurns`, // 客户的待转结列表
  CUSTOM_CAN_MOVEOUT: `${baseUrl}/api/bszb/incubator/custom/canMoveOut`, // 客户是否迁出
  CUSTOM_MOVEOUT: `${baseUrl}/api/bszb/incubator/custom/moveOut`, // 客户迁出操作
  CUSTOM_MOVEOUT_REMIND: `${baseUrl}/api/bszb/incubator/custom/move/out/remind`, // 客户45天内到期迁出提醒
  CUSTOM_MOVEOUT_OVERDUE: `${baseUrl}/api/bszb/incubator/custom/move/out/overdue`, // 客户逾期迁出提醒
  CUSTOM_FINANCING_STATUS: `${baseUrl}/api/bszb/incubator/custom/financing/status`, // 更改融资状态

  /** 客户标签 */
  CUSTOM_TAG_DEFAULT: `${baseUrl}/api/bszb/incubator/custom/tag/default`, // 默认标签
  CUSTOM_TAG_SAVE: `${baseUrl}/api/bszb/incubator/custom/tag/relate/save`, // 标签关联

  CUSTOM_PENDING: `${baseUrl}/api/bszb/incubator/custom/business/payable/pending`, // 待收款
  CUSTOM_PENDING_EXPORT: `${baseUrl}/api/bszb/incubator/custom/business/payable/pending/export`, // 待收款导出
  CUSTOM_PAID: `${baseUrl}/api/bszb/incubator/custom/business/payable/paid`, // 已收款  -- 全部/工位/地址
  CUSTOM_PAID_DEPOSIT: `${baseUrl}/api/bszb/incubator/custom/business/payable/paid/deposit`, // 已收款 -- 在签押金
  CUSTOM_PAID_LIQUIDATE: `${baseUrl}/api/bszb/incubator/custom/business/payable/paid/liquidate`, // 已收款 -- 违约金
  CUSTOM_PAID_TURN: `${baseUrl}/api/bszb/incubator/custom/business/payable/paid/turn`, // 已收款 -- 已到期押金(已转结)
  CUSTOM_PAID_TODO: `${baseUrl}/api/bszb/incubator/custom/business/payable/paid/todo`, // 已收款 -- 已到期押金(待处理)
  CUSTOM_OBSOLETE: `${baseUrl}/api/bszb/incubator/custom/business/payable/obsolete`, // 作废款
  CUSTOM_PENDINGREFUND: `${baseUrl}/api/bszb/incubator/custom/business/payable/pendingRefund`, // 待退款
  CUSTOM_PENDINGREFUND_TODO: `${baseUrl}/api/bszb/incubator/custom/business/payable/pendingRefund/todo`, // 退款时待退款列表
  CUSTOM_REFUND: `${baseUrl}/api/bszb/incubator/custom/business/payable/refunded`, // 已退款
  CUSTOM_PAYABLE_DETAIL_STATIS: `${baseUrl}/api/bszb/incubator/custom/business/payable/detail/statistics`, // 付款约定明细统计
  CUSTOM_PAYABLE_STATIS: `${baseUrl}/api/bszb/incubator/custom/business/payable/statistics`, // 付款约定统计

  CUSTOM_SIGNING: `${baseUrl}/api/bszb/incubator/custom/business/signing`, // 在签合同
  CUSTOM_ARCHIVING: `${baseUrl}/api/bszb/incubator/custom/business/archiving`, // 待归档合同
  CUSTOM_ARCHIVIED: `${baseUrl}/api/bszb/incubator/custom/business/archived`, // 归档合同

  /** 孵化器合同付款约定 */
  INCU_PAYABLE_COLLECTION: `${baseUrl}/api/bszb/incubator/business/payable/collection`, // 催收款
  INCU_PAYABLE_OVERDUE: `${baseUrl}/api/bszb/incubator/business/payable/overdue`, // 逾期款
  INCU_PAYABLE_ABNORMAL: `${baseUrl}/api/bszb/incubator/business/payable/abnormal`, // 异常款
  INCU_PAYABLE_PENDING: `${baseUrl}/api/bszb/incubator/business/payable/pending`, // 待收款
  INCU_PAYABLE_PENDING_EXPORT: `${baseUrl}/api/bszb/incubator/business/payable/pending/export`, // 待收款导出
  INCU_PAYABLE_PAID: `${baseUrl}/api/bszb/incubator/business/payable/paid`, // 已收款
  PAYABLE_PAID_DEPOSIT: `${baseUrl}/api/bszb/incubator/business/payable/paid/deposit`, // 已收款 -- 在签押金
  PAYABLE_PAID_LIQUIDATE: `${baseUrl}/api/bszb/incubator/business/payable/paid/liquidate`, // 已收款 -- 违约金
  PAYABLE_PAID_TURN: `${baseUrl}/api/bszb/incubator/business/payable/paid/turn`, // 已收款 -- 已到期押金(已转结)
  PAYABLE_PAID_TODO: `${baseUrl}/api/bszb/incubator/business/payable/paid/todo`, // 已收款 -- 已到期押金(待处理)
  INCU_PAYABLE_OBSOLETE: `${baseUrl}/api/bszb/incubator/business/payable/obsolete`, // 作废款
  INCU_PAYABLE_PENDINGREFUND: `${baseUrl}/api/bszb/incubator/business/payable/pendingRefund`, // 待退款
  PAYABLE_PENDINGREFUND_REMIND: `${baseUrl}/api/bszb/incubator/business/payable/pendingRefund/remind`, // 待退款提醒
  INCU_PAYABLE_REFUNDED: `${baseUrl}/api/bszb/incubator/business/payable/refunded`, // 已退款
  INCU_PAYABLE_STATISTICS: `${baseUrl}/api/bszb/incubator/business/payable/statistics`, // 付款约定统计
  INCU_PAYABLE_CONFIRM: `${baseUrl}/api/bszb/incubator/business/payable/confirm`, // 付款约定确认金额
  INCU_PAYABLE_CANCEL: `${baseUrl}/api/bszb/incubator/business/payable/cancel`, // 付款约定取消金额
  INCU_PAYABLE_DETAIL: `${baseUrl}/api/bszb/incubator/business/payable/detail`, // 付款约定详情
  INCU_PAYABLE_REFUND: `${baseUrl}/api/bszb/incubator/business/payable/refund`, // 待处理押金退款处理
  PAYABLE_DETAIL_STATISTICS: `${baseUrl}/api/bszb/incubator/business/payable/detail/statistics`, // 付款约定明细统计
  PAYABLE_SLEEP_SAVE: `${baseUrl}/api/bszb/incubator/business/payable/sleep/save`, // 已到期押金休眠

  /** 孵化器合同 */
  INCU_INDEPOSIT_TURN: `${baseUrl}/api/bszb/incubator/business/indeposit/turn/save`, // 合同转结
  INCU_BUSINESS_REMIND: `${baseUrl}/api/bszb/incubator/business/remind`, // 合同提醒
  INCU_BUSINESS_OVERDUE: `${baseUrl}/api/bszb/incubator/business/overdue`, // 逾期合同
  INCU_BUSINESS_SIGNING: `${baseUrl}/api/bszb/incubator/business/signing`, // 在签合同
  INCU_BUSINESS_ARCHIVING: `${baseUrl}/api/bszb/incubator/business/archiving`, // 待归档合同
  INCU_BUSINESS_ARCHIVED: `${baseUrl}/api/bszb/incubator/business/archived`, // 档合同
  ARCHIVE_BUSINESS: `${baseUrl}/api/bszb/incubator/business/archive`, // 合同归档

  /** 终止合同 */
  TERMINATION_LIST: `${baseUrl}/api/bszb/incubator/business/termination/list`, // 终止合同列表
  TERMINATION_MY: `${baseUrl}/api/bszb/incubator/business/termination/my`, // 我的终止合同申请列表
  TERMINATION_INFO: `${baseUrl}/api/bszb/incubator/business/termination/info`, // 终止合同详情
  TERMINATION_SAVE: `${baseUrl}/api/bszb/incubator/business/termination/save`, // 终止合同保存
  TERMINATION_NEXT: `${baseUrl}/api/bszb/incubator/business/termination/nextActivity`, // 流程审核
  TERMINATION_NEXT_SCAN: `${baseUrl}/api/bszb/incubator/business/termination/nextActivityScan`, // 经办人提交文件扫描件
  TERMINATION_NEXT_ARCHIVE: `${baseUrl}/api/bszb/incubator/business/termination/nextActivityArchive`, // 行政文件归档
  TERMINATION_RETURN: `${baseUrl}/api/bszb/incubator/business/termination/returnActivity`, // 合同终止流程打回
  TERMINATION_CALLBACK: `${baseUrl}/api/bszb/incubator/business/termination/callbackActivity`, // 收回合同终止流程
  TERMINATION_DELETE: `${baseUrl}/api/bszb/incubator/business/termination/delete`, // 终止合同删除
  TERMINATION_WORKFLOW: `${baseUrl} /api/bszb/incubator/business/termination/workflow`, // 终止合同流程

  /** 处理退款 */
  BACK_LIST: `${baseUrl}/api/bszb/incubator/business/back/list`, // 退款列表
  BACK_MY: `${baseUrl}/api/bszb/incubator/business/back/my`, // 我的退款申请列表
  BACK_INFO: `${baseUrl}/api/bszb/incubator/business/back/info`, // 退款详情
  BACK_SAVE: `${baseUrl}/api/bszb/incubator/business/back/save`, // 退款保存
  BACK_NEXT: `${baseUrl}/api/bszb/incubator/business/back/nextActivity`, // 流程审核
  BACK_RETURN: `${baseUrl}/api/bszb/incubator/business/back/returnActivity`, // 合同终止流程打回
  BACK_CALLBACK: `${baseUrl}/api/bszb/incubator/business/back/callbackActivity`, // 收回合同终止流程
  BACK_DELETE: `${baseUrl}/api/bszb/incubator/business/back/delete`, // 退款删除
  BACK_WORKFLOW: `${baseUrl} /api/bszb/incubator/business/back/workflow`, // 退款流程

  /** 错款退款申请 */
  REFUND_LIST: `${baseUrl}/api/bszb/incubator/refund/list`, // 退款列表
  REFUND_MY: `${baseUrl}/api/bszb/incubator/refund/my`, // 我的退款申请列表
  REFUND_INFO: `${baseUrl}/api/bszb/incubator/refund/info`, // 退款详情
  REFUND_SAVE: `${baseUrl}/api/bszb/incubator/refund/save`, // 退款保存
  REFUND_NEXT: `${baseUrl}/api/bszb/incubator/refund/nextActivity`, // 流程审核
  REFUND_RETURN: `${baseUrl}/api/bszb/incubator/refund/returnActivity`, // 合同终止流程打回
  REFUND_CALLBACK: `${baseUrl}/api/bszb/incubator/refund/callbackActivity`, // 收回合同终止流程
  REFUND_DELETE: `${baseUrl}/api/bszb/incubator/refund/delete`, // 退款删除
  REFUND_WORKFLOW: `${baseUrl} /api/bszb/incubator/refund/workflow`, // 退款流程

  /** 开票 */

  INVOICE_LIST: `${baseUrl}/api/bszb/incubator/custom/invoice/list`, // 开票合同列表
  INVOICE_MY: `${baseUrl}/api/bszb/incubator/custom/invoice/my`, // 我的开票合同申请列表
  INVOICE_INFO: `${baseUrl}/api/bszb/incubator/custom/invoice/info`, // 开票合同详情
  INVOICE_SAVE: `${baseUrl}/api/bszb/incubator/custom/invoice/save`, // 开票合同保存
  INVOICE_NEXT: `${baseUrl}/api/bszb/incubator/custom/invoice/nextActivity`, // 流程审核
  INVOICE_RETURN: `${baseUrl}/api/bszb/incubator/custom/invoice/returnActivity`, // 合同开票流程打回
  INVOICE_CALLBACK: `${baseUrl}/api/bszb/incubator/custom/invoice/callbackActivity`, // 收回合同开票流程
  INVOICE_DELETE: `${baseUrl}/api/bszb/incubator/custom/invoice/delete`, // 开票合同删除
  INVOICE_WORKFLOW: `${baseUrl}/api/bszb/incubator/custom/invoice/workflow`, // 开票合同流程
  INVOICE_INVALID: `${baseUrl}/api/bszb/incubator/custom/invoice/invalid`, // 发票作废
  INVOICE_INCU_AVAILABLE: `${baseUrl}/api/bszb/incubator/custom/invoice/incubator/available`, // 孵化器可开票金额
  INVOICE_CUSTOM_AVAILABLE: `${baseUrl}/api/bszb/incubator/custom/invoice/available`, // 客户可开票金额
  INVOICE_CUSTOM_DOING: `${baseUrl}/api/bszb/incubator/custom/invoice/statistics/doing`, // 审核中的开票金额
  INVOICE_CUSTOM_TODO: `${baseUrl}/api/bszb/incubator/custom/invoice/todo`, // 待开票列表

  /** 财务分析 */
  AIMS_CONFIG: `${baseUrl}/api/bszb/incubator/finance/aims/config`, // 收入目标设置
  FINANCE_INCOME: `${baseUrl}/api/bszb/incubator/finance/income/aims`, // 孵化器收入情况
  FINANCE_EXPENDITURE: `${baseUrl}/api/bszb/incubator/finance/expenditure/budget`, // 孵化器首页支出情况
  FINANCE_INVESTMENT: `${baseUrl}/api/bszb/incubator/finance/investment`, // 投资现金回报计算
  FINANCE_BY_TYPE: `${baseUrl}/api/bszb/incubator/finance/statisticsGroupByType`, // 财务数据分析 -- 类目
  FINANCE_BY_MONTH: `${baseUrl}/api/bszb/incubator/finance/statisticsGroupByMonth`, // 财务数据分析 -- 月份
  FINANCE_RECORD: `${baseUrl}/api/bszb/incubator/finance/record/list`, // 财务数据分析 -- 明细
  FINANCE_BUDGET_BY_TYPE: `${baseUrl}/api/bszb/incubator/finance/statisticsGroupBudgetByType`, // 预算财务数据分析 -- 类目
  FINANCE_BUDGET_BY_MONTH: `${baseUrl}/api/bszb/incubator/finance/statisticsGroupBudgetByMonth`, // 预算财务数据分析 -- 月份
  FINANCE_BUDGET_RECORD: `${baseUrl}/api/bszb/incubator/finance/record/budget`, // 预算财务数据分析 -- 明细
  BUBESINESS_BY_TYPE: `${baseUrl}/api/bszb/incubator/finance/unbusiness/statisticsGroupByType`, // 非合同款收入 -- 类目
  BUBESINESS_RECORD: `${baseUrl}/api/bszb/incubator/finance/unbusiness/list`, // 非合同款收入 -- 类目
  PROFIT_CHART: `${baseUrl}/api/bszb/incubator/finance/profit`, // 利润跟踪 -- 图表
  PROFIT_RECORD: `${baseUrl}/api/bszb/incubator/finance/profit/detail`, // 利润更新详情
  FINANCE_EXPORT: `${baseUrl}/api/bszb/incubator/finance/record/export`, // 导出
  RELATE_TODO: `${baseUrl}/api/bszb/incubator/finance/income/relate/todo`, // 孵化器待关联客户资金列表
  RELATE_DONE: `${baseUrl}/api/bszb/incubator/finance/income/relate/done`, // 孵化器已关联客户资金列表
  RELATE_NON: `${baseUrl}/api/bszb/incubator/finance/income/relate/non`, // 孵化器不关联客户资金列表
  FINANCE_PAYABLE: `${baseUrl}/api/bszb/incubator/finance/payable`, // 资金匹配的账单列表
  RELATE_SAVE: `${baseUrl}/api/bszb/incubator/finance/income/relate/save`, // 资金关联客户
  RELATE_CANCEL: `${baseUrl}/api/bszb/incubator/finance/income/relate/cancel`, // 资金关联客户
};

export const task = {
  /** 项目管理 */
  PROJ_LIST: `${baseUrl}/api/bszb/task/project/list`, // 项目监控
  PROJ_LAU_LIST: `${baseUrl}/api/bszb/task/project/launch/list`, // 我发起的项目列表
  PROJ_RECEIVE_LIST: `${baseUrl}/api/bszb/task/project/receive/list`, // 我收到的项目列表
  PROJ_SAVE: `${baseUrl}/api/bszb/task/project/save`, // 项目新增
  PROJ_DELETE: `${baseUrl}/api/bszb/task/project/delete`, // 项目删除
  PROJ_INFO: `${baseUrl}/api/bszb/task/project/info`, // 项目详情
  PROJ_UPD_STATUS: `${baseUrl}/api/bszb/task/project/updateStatus`, // 项目状态修改
  PROJ_TASK_LIST: `${baseUrl}/api/bszb/task/project/task/list`, // 项目任务列表
  PROJ_FILES_LIST: `${baseUrl}/api/bszb/task/project/file/list`, // 项目文件列表
  PROJ_FILES_SAVE: `${baseUrl}/api/bszb/task/project/file/save`, // 项目文件保存
  PROJ_FILES_DELETE: `${baseUrl}/api/bszb/task/project/file/delete`, // 项目文件删除
  PROJ_STAT_RATE: `${baseUrl}/api/bszb/task/project/statistics/completion/rate`, // 任务完成率统计

  /** 项目目录管理 */
  PROJ_DIR_LIST: `${baseUrl}/api/bszb/task/directory/list`, // 项目目录列表
  PROJ_DIR_INFO: `${baseUrl}/api/bszb/task/directory/info`, // 项目目录详情
  PROJ_DIR_SAVE: `${baseUrl}/api/bszb/task/directory/save`, // 项目目录保存
  PROJ_DIR_DEL: `${baseUrl}/api/bszb/task/directory/delete`, // 项目目录删除

  /** 任务管理 */
  TASK_LIST: `${baseUrl}/api/bszb/task/task/list`, // 任务监控
  TASK_SEARCH: `${baseUrl}/api/bszb/task/task/search`, // 任务高级搜索
  TASK_LAU_LIST: `${baseUrl}/api/bszb/task/task/launch/list`, // 我发起的任务列表
  TASK_RECEIVE_LIST: `${baseUrl}/api/bszb/task/task/receive/list`, // 我收到的任务列表
  TASK_SEARCH_LIST: `${baseUrl}/api/bszb/task/task/search`, // 我收到的任务列表高级搜索
  TASK_CHECK_LIST: `${baseUrl}/api/bszb/task/task/check/list`, // 待审核的任务列表监控
  TASK_CHECK_MY: `${baseUrl}/api/bszb/task/task/check/my`, // 我的待审核的任务列表
  TASK_SAVE: `${baseUrl}/api/bszb/task/task/save`, // 任务新增
  TASK_COLLECT: `${baseUrl}/api/bszb/task/task/collect`, // 任务收藏
  TASK_UNCOLLECT: `${baseUrl}/api/bszb/task/task/uncollect`, // 任务取消收藏
  TASK_INFO: `${baseUrl}/api/bszb/task/task/info`, // 任务详情
  TASK_FILES: `${baseUrl}/api/bszb/task/task/files`, // 任务附件
  TASK_LOG: `${baseUrl}/api/bszb/task/task/log`, // 任务日志
  TASK_COMPLETION: `${baseUrl}/api/bszb/task/task/completion`, // 任务完成
  TASK_DISCARD: `${baseUrl}/api/bszb/task/task/discard`, // 任务废弃
  TASK_DELETE: `${baseUrl}/api/bszb/task/task/delete`, // 任务删除

  /** 任务审核 */
  TASKCHECK_NEXT: `${baseUrl}/api/bszb/task/task/nextActivity`, // 任务审核
  TASKCHECK_RETURN: `${baseUrl}/api/bszb/task/task/returnActivity`, // 任务退回
  TASKCHECK_CALLBACK: `${baseUrl}/api/bszb/task/task/callbackActivity`, // 任务收回
  TASKCHECK_WORKFLOW: `${baseUrl}/api/bszb/task/task/workflow`, // 任务审核流程

  /** 标签管理 */
  TAG_LIST: `${baseUrl}/api/bszb/common/tag/list`, // 标签列表
  TAG_DEL: `${baseUrl}/api/bszb/common/tag/delete`, // 标签删除
  TAG_RELATE_DEL: `${baseUrl}/api/bszb/common/tag/relate/delete`, // 标签关联删除
};



// WEBPACK FOOTER //
// ./src/api/req.js